import { lazy } from "react";

const routes = [
  {
    path: "/setting",
    element: lazy(() => import("../pages/Setting")),
  },
  {
    path: "/setting/edit/:id",
    element: lazy(() => import("../pages/Setting/edit")),
  },
];

export default routes;
